<template>
    <div class="container">
        <div class="list" id="list" ref="list">
            <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
                :duration="{ enter: 1000 }">
                <ul :style="{ transform: 'translateY(' + transformNum + 'rem)' }">
                    <li v-for="(item, index) in reversedList" :key="index" v-if="item.msg.show">
                        <div class="container-item"
                            :style="{ 'flex-direction': item.msg.left === 'left' ? '' : 'row-reverse' }">
                            <img class="head" :src="item.head.img" :style="generateInnerStyles(item.head.style)" />
                            <div class="content">
                                <div class="text" :style="generateInnerStyles(item.msg.contentStyle)">
                                    {{ item.content }}
                                </div>
                                <img class="head" :src="item.msg.img" :style="generateInnerStyles(item.msg.style)" />
                            </div>
                        </div>
                    </li>
                </ul>
            </transition>
        </div>
    </div>
</template>

<script>
/**
* 字符替换
*/
const formatString = (string, regStr, reqStr) => {
    const reg = new RegExp(regStr, 'g');
    return string.replace(reg, reqStr);
};

// 处理特殊的样式值
const supplementStyle = (key, val) => {
    if (key === 'background-image' && val !== 'none') {
        return `url(${val})`;
    }
    return val;
};
export const transformStyle = (cssData = {}) => {
    const supportAttrs = ['width', 'height', 'background_image', 'margin', 'top', 'left', 'right', 'bottom', 'padding'];
    const style = supportAttrs.reduce((result, attr) => {
        if (!cssData[attr]) {
            return result;
        }
        const key = formatString(attr, '_', '-');
        const value = supplementStyle(key, cssData[attr]);
        result += `${key}: ${value}; `;
        return result;
    }, '');
    return `${cssData.style || ''}${style}`;
};
export default {
    name: "chatModule",
    props: {
        msglist: {
            type: Array,
            default: () => []
        },
        step: {
            type: Number,
            default: () => 0
        },
        // 战力过少
        mini: {
            type: Boolean,
            default: () => false
        },
        // 选择是否抗辩
        info: {
            type: Boolean,
            default: () => false
        }
    },
    data: () => {
        return {
            transformNum: 2,
        }
    },
    computed: {
        reversedList() {
            return [...this.msglist].reverse();
        },
    },
    watch: {
        step: {
            handler(newVal, oldValue) {
                if (this.mini) {
                    this.transformNum = this.transformNum - 2
                } else {
                    if (newVal === 5) {
                        this.transformNum = this.transformNum - 6
                    }
                    if (newVal === 7 && this.info) {
                        this.transformNum = this.transformNum - 2
                    }
                    if (newVal === 6) {
                        this.transformNum = this.transformNum - 4
                    }
                    const num = newVal - oldValue
                    if (newVal !== 4 && newVal !== 6) {
                        this.transformNum = this.transformNum - 2 * num
                    }
                }
                if (newVal === 1) {
                    this.transformNum = 2
                }
            },
            deep: true
        },
    },
    mounted() {
        // this.startQueueAnimation();
        console.log(this.msglist, 'chatModule')
    },
    methods: {
        // 处理行内样式
        generateInnerStyles(cssAttr) {
            return transformStyle(cssAttr);
        },
        startQueueAnimation() {
            let isRemoving = true;

            const processQueue = async () => {
                if (this.msglist.length > 0) {
                    if (isRemoving) {
                        // 移除首项并保留副本
                        const removedItem = JSON.parse(JSON.stringify(this.msglist[0]));
                        // this.msglist.shift();

                        // 1秒后执行添加操作
                        await new Promise(resolve => setTimeout(resolve, 1000));
                        this.msglist.unshift(removedItem);
                    }

                    // 切换状态并设置下次执行
                    isRemoving = !isRemoving;
                    setTimeout(processQueue, 1000);
                }
            }

            // 初始启动
            processQueue();
        }

    }
}
</script>

<style scoped lang="less">
.container {
    ul {
        padding: 0;
        margin: 0;
        display: flex;
        flex-direction: column-reverse;
        transition: all 1s ease-in-out;
        width: 85%;
    }

    li {
        list-style: none;
        height: 2rem;
    }

    li:last-child {
        margin-top: 0.2rem;
    }

    .list {
        width: 100%;
        height: 100%;
        margin-bottom: 45px;
    }

    @font-face {
        font-family: Regular;
        src: url('//static2.qcplay.com/fonts/SourceHanSansCN/SourceHanSansCN-Regular.otf')
    }

    .container-item {
        display: flex;
        padding: 10px 15px;

        .head {
            width: 40px;
            height: 40px;
            margin: 0.1rem;
        }

        .content {
            .text {
                padding: 15px 10px;
                padding-left: 30px;
                position: absolute;
                font-family: Regular;
                font-weight: 400;
                font-size: 28px;
                color: #746E67;
                line-height: 34px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                z-index: 2;
                box-sizing: border-box;
            }

            .img {
                width: 100px;
                border-bottom-right-radius: 10px;
                border-top-right-radius: 10px;
                border-bottom-left-radius: 10px;
            }
        }

    }
}
</style>


// WEBPACK FOOTER //
// src/pages/snail/5thReport/components/chatModule.vue